import { convertDate, toCapitalizeCase, convertToCurrency, convertNumberBR, convertPercentage } from 'xpi-black-ui/Utils/helpers';
import uuidv4 from 'uuidv4';

const whiteList = ['abev3', 'bbas3', 'bbdc4', 'ggbr4', 'itsa4', 'itub4', 'petr4', 'usim5', 'vale3'];

const assetIsInWhiteList = asset => (
  whiteList.includes(asset?.toLowerCase())
);

const getEnabledAssets = assets => {
  let enabledAssets = assets.filter(asset => (
    assetIsInWhiteList(asset)
  ));

  enabledAssets = enabledAssets.map(asset => ({
    value: asset, label: asset
  }));

  return enabledAssets;
}

export const normalizeFilters = filters => ({
  assets: getEnabledAssets(filters.ativos),
  structures: filters.estruturas.map(structure => ({
    value: structure,
    label: toCapitalizeCase(structure),
  })),
  holidays: filters.feriados.map(holiday => holiday.replace(/T.*/g, '')),
});

export const isStock = (type) => (type === 'Stock');

const isLegCustomizedOfBooster = leg => (
  leg.ordemExibicao == 3 && leg.estrutura === "BOOSTER"
);

export const normalizeOperationDetail = operation => ({
  ...operation,
  id: uuidv4(),
  invalid: true,
  estrutura: toCapitalizeCase(operation.estrutura),
  isEnabledToSave: assetIsInWhiteList(operation.ativo),
  limiteDisponivelFormatado: convertNumberBR(operation.limiteDisponivel),
  withStock: operation.configuracaoEstrutura.some(structure => isStock(structure.tipo)),
  vencimentoFormatado: convertDate(operation.vencimento),
  nomeImagem: operation.ativo.replace(/[0-9]/g, ''),
  configuracaoEstrutura: operation.configuracaoEstrutura.map(leg => ({
    ...leg,
    id: uuidv4(),
    isStock: isStock(leg.tipo),
    strike: {
      ...leg.strike,
      value: 0,
      minimoFormatado: leg.strike.minimo > 0 ? `${convertNumberBR(leg.strike.minimo, 2)} %` : 0,
      maximoFormatado: leg.strike.maximo > 0 ? `${convertNumberBR(leg.strike.maximo, 2)} %` : 0,
    },
    precoReferenciaFormatado: convertToCurrency(operation.configuracaoEstrutura[0].precoReferencia),
    readonly: isLegCustomizedOfBooster(leg),
  })),
});

export const updateOperation = (operation, isValid, commissionMax, commissionMinimum, baldPrice, reference) => {
  const updatedOperation = {
    ...operation,
    invalid: !isValid,
    comission: {
      ...operation.comission,
      commissionMax,
      commissionMinimum,
      valueFormatted: operation.comission ? operation.comission.valueFormatted : 50,
    },
    baldPrice,
    baldPriceCurrency: convertToCurrency(baldPrice),
    baldPricePercentage: `${convertNumberBR(((baldPrice / reference) * 100).toFixed(2), 2)} %`,
    configuracaoEstrutura: operation.configuracaoEstrutura.map(leg => ({
      ...leg,
      precoReferencia: reference,
      precoReferenciaFormatado: convertToCurrency(reference)
    })),
  };

  return updateValuesOperation({ comissionSlider: updatedOperation.comission.valueFormatted, operation: updatedOperation });
};

export const updateValuesOperation = ({ comissionSlider, operation }) => {
  const comissionValueFormatted = convertNumberBR(parseFloat(comissionSlider));

  let comissionSelected = (operation.comission.commissionMax * comissionSlider)/100;
  comissionSelected = comissionSelected < operation.comission.commissionMinimum ? operation.comission.commissionMinimum : comissionSelected;
  const comissionCurrency = convertToCurrency(comissionSelected);

  const finalPriceValue = operation.baldPrice ? operation.baldPrice.toFixed(2) - comissionSelected.toFixed(2) : 0;
  const finalPriceCurrency = convertToCurrency(finalPriceValue);
  const finalPricePercentage = convertPercentage(((finalPriceValue / operation.configuracaoEstrutura[0].precoReferencia) * 100), 2);

  return {
    ...operation,
    comission: {
      ...operation.comission,
      value: comissionSlider,
      currency: comissionCurrency,
      selected: comissionSelected,
      valueFormatted: comissionValueFormatted
    },
    finalPrice: {
      value: finalPriceValue,
      currency: finalPriceCurrency,
      percentage: finalPricePercentage,
    }
  }
};

export const handlerCustomStructure = structure => (
  structure.map((leg, index) => {
    let structureLeg = leg;
    if (isLegCustomizedOfBooster(leg)) {
      const prevLeg = structure[index-1];
      structureLeg = {
        ...leg,
        strike: prevLeg.strike,
        invalid: prevLeg.invalid
      }
    }

    return structureLeg;
  })
);
